import { Navigate, Route } from "react-router";
import { lazy } from "react";

import Items from "./Items";
import StoreLayout from "./StoreLayout";
import { CustomerAccount } from "../CustomerDetails/CustomerAccount";
import StoreOrder from "../SalesAndInvoicing/StoreOrder";
import ContactUs from "./ContactUs";
// import IsServiceAvailable from "../IsServiceAvailable";
import { appSettings } from "../../config";
import ContentPage from "./ContentPage";
import ChangePassword from "../ChangePassword";
import NewCustominvoice from "../Reports/NewCustominvoice";
import NewStoreDashboard from "../Reports/NewStoreDashboard";
import OnlineStorePostPayment from "../OnlineStorePostPayment";
import MenuPage from "../CustomerDetails/MenuPage";
import { useStoreActions, useStoreState } from "easy-peasy";
import { LoginCustomerPage } from "../CustomerDetails/LoginCustomerPage";
import { RegisterCustomerPage } from "../CustomerDetails/RegisterCustomerPage";
import HomePage from "./HomePage";
import StoreHomePage from "./HomePage";
import CustomMenuPage from "../CustomerDetails/CustomMenuPage";
const CustomCustomerInvoice = lazy(() =>
  import("../CustomerDetails/CustomInvoice")
);

// Lazy imports ------------------------------------------------------
const Profile = lazy(() => import("../CustomerDetails/Profile"));
const CustomerLedger = lazy(() => import("../CustomerDetails/Ledger"));
const CustomerPayments = lazy(() => import("../CustomerDetails/Payments"));
const CustomerInvoices = lazy(() => import("../CustomerDetails/Invoices"));
const CustomerOrders = lazy(() => import("../CustomerDetails/Orders"));
const Cart = lazy(() => import("../SalesAndInvoicing/Cart"));
const CustomerStoreQuotes = lazy(() =>
  import("../CustomerDetails/CustomerStoreQuotes")
);

const StoreRoutes = (
  /*  <Route element={<IsServiceAvailable serviceType="store" />}> */

  <Route>
    <Route path="store/menu" element={<MenuPage />} />
    <Route path="store/custom-menu" element={<CustomMenuPage />} />
    <Route element={<StoreLayout />}>
      <Route path={appSettings.storeBaseUrl}>
        <Route index element={<Navigate to="index" />} />
        <Route path="index" element={<StoreHomePage />} />
        <Route path="home" element={<Items />} />
        <Route path="cart" element={<Cart />} />
        <Route path="contact-us" element={<ContactUs />} />
        <Route path="login" element={<LoginCustomerPage />} />
        <Route path="register" element={<RegisterCustomerPage />} />

        <Route path="account" element={<CustomerAccount />}>
          <Route index element={<Navigate to="profile" />} />
          <Route path="profile" element={<Profile />} />
          <Route path="ledger" element={<CustomerLedger />} />
          <Route path="payments" element={<CustomerPayments />} />
          <Route path="invoices" element={<CustomerInvoices />} />
          <Route path="dashboard" element={<NewStoreDashboard />} />
          <Route path="make-payment" element={<OnlineStorePostPayment />} />

          <Route
            path="paid-invoices"
            element={<CustomCustomerInvoice invoiceType="paid" />}
          />
          <Route
            path="unpaid-invoices"
            element={<CustomCustomerInvoice invoiceType="unpaid" />}
          />
          <Route
            path="upcoming-invoices"
            element={<CustomCustomerInvoice invoiceType="upcoming" />}
          />
          <Route
            path="overdue-invoices"
            element={<CustomCustomerInvoice invoiceType="overdue" />}
          />
          <Route
            path="credited-invoices"
            element={<CustomCustomerInvoice invoiceType="credited" />}
          />
          <Route path="orders" element={<CustomerOrders />} />
          <Route path="quotes" element={<CustomerStoreQuotes />} />
        </Route>
        <Route path="categories" element={<Items />}>
          <Route path=":categoryName" element={<Items />} />
        </Route>
        <Route path="products" element={<Items />}>
          <Route path=":productName" element={<Items />} />
        </Route>
        <Route path="track-order" element={<StoreOrder />} />
        <Route path="terms-and-conditions" element={<ContentPage key={1} />} />
        <Route path="return-policy" element={<ContentPage key={2} />} />
        <Route
          path="customer-products"
          element={<Items usage="customer-products" />}
        />
        <Route path="change-password" element={<ChangePassword />} />
      </Route>
    </Route>
  </Route>
  /*   </Route> */
);

export default StoreRoutes;
